/* src/app/shared/claim-adjust-modal-prompt/claim-adjust-modal-prompt.component.css */
.font9 {
  font-size: 9px;
}
/*# sourceMappingURL=claim-adjust-modal-prompt.component.css.map */
